<template>
  <div :class="b()" :style="styleSizeName" ref="main">
    <avue-select
      v-if="isSelect"
      :dic="typeof dataChart === 'string' ? [] : dataChart"
      :style="styleSelectName"
      v-model="active"
    ></avue-select>
    <div :class="b('list')" :style="tabs2Dir" v-else>
      <div
        :class="b('item')"
        :style="[styleName, styleActiveName(item)]"
        v-for="(item, index) in dataChart"
        :key="index"
        @click="
          handleClick(item.value);
          goLink();
        "
      >
        <div
          v-if="item.icon"
          :class="b('icon')"
          :style="[styleIconName, styleIconBgName(item), styleIconActiveName(item)]"
        ></div>
        <span>{{ item.label }}</span>
      </div>
    </div>
  </div>
</template>

<script>
import init from '@/mixins/chart';
export default {
  name: 'tabs2',
  inject: ['contain'],
  mixins: [init],
  data() {
    return {
      active: ''
    };
  },
  watch: {
    dataChart: {
      handler(val) {
        if (val.length !== 0) {
          this.active = val[0].value;
          const isBuild = this.$route.name === 'build';
          !isBuild && this.handleClick(this.active);
        }
      },
      immediate: true
    }
  },
  computed: {
    tabs2Dir() {
      return {
        flexDirection: this.option.tabs2Flex || 'row'
      };
    },
    isSelect() {
      return this.type === 'select';
    },
    type() {
      return this.option.type;
    },
    paramName() {
      return this.option.paramName;
    },
    iconSize() {
      return this.option.iconSize || 20;
    },
    styleSelectName() {
      return Object.assign(
        {
          fontSize: this.setPx(this.option.fontSize || 30)
        },
        this.styleSizeName
      );
    },
    styleIconName() {
      return Object.assign({
        marginRight: this.setPx(this.option.iconSplit),
        width: this.setPx(this.option.iconSize),
        height: this.setPx(this.option.iconSize)
      });
    },
    styleName() {
      return Object.assign(
        (() => {
          if (this.option.backgroundImage) {
            return {
              backgroundImage: `url(${this.option.backgroundImage})`,
              backgroundSize: '100% 100%'
            };
          }
          return {};
        })(),
        {
          borderColor: this.option.borderColor || '#fff',
          borderStyle: 'solid',
          borderWidth: this.setPx(this.option.borderWidth || 0),
          margin:
            this.option.tabs2Flex == 'row'
              ? `0 ${this.setPx(this.option.split)}`
              : `${this.setPx(this.option.split)} 0`,
          backgroundColor: this.option.backgroundColor,
          fontSize: this.setPx(this.option.fontSize || 30),
          fontWeight: this.option.fontWeight || 'normal',
          color: this.option.color
        }
      );
    },
    allPane() {
      return this.contain.findAllNav(this.child.index);
    },
    currentPane() {
      let index = this.dataChart.findIndex(item => item.value === this.active);
      return this.contain.findAllNav(this.child.index[index]);
    }
  },
  created() {},
  mounted() {},
  methods: {
    styleIconBgName(item) {
      if (item.icon) {
        return {
          backgroundImage: `url(${item.icon})`,
          backgroundSize: '100% 100%'
        };
      }
    },
    styleIconActiveName(item) {
      if (this.active == item.value && item.empIcon) {
        return {
          backgroundImage: `url(${item.empIcon})`,
          backgroundSize: '100% 100%'
        };
      }
    },
    styleActiveName(item) {
      if (this.active == item.value) {
        return Object.assign(
          (() => {
            if (this.option.empBackgroundImage) {
              return {
                backgroundImage: `url(${this.option.empBackgroundImage})`,
                backgroundSize: '100% 100%'
              };
            }
            return {};
          })(),
          {
            borderColor: this.option.empBorderColor || '#fff',
            borderStyle: 'solid',
            borderWidth: this.setPx(this.option.empBorderWidth || 0),
            color: this.option.empColor
          }
        );
      }
    },
    handleClick(val) {
      this.active = val;
      // this.click({
      //   type: this.name,
      //   child: this.child,
      //   value: this.active
      // })
      this.click('handleDisplay', {
        current: this.currentPane,
        all: this.allPane
      });
    },
    goLink() {
      this.imgClick();
    }
  },
  props: {
    option: {
      type: Object,
      default: () => {
        return {};
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.avue-echart {
  &-tabs2 {
    .el-select {
      width: 100%;
    }
    .el-select,
    .el-input,
    input {
      height: 100%;
    }
    .el-input {
      font-size: inherit;
    }
    &__list {
      display: flex;
      justify-content: space-around;
      align-items: center;
      // flex-direction: column;
      height: 100%;
    }
    &__icon {
      margin-right: 10px;
    }
    &__item {
      width: 100%;
      height: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
      box-sizing: border-box;
    }
  }
}
</style>
